export type AllergenCellState = 'contains' | 'modifiable' | 'none'

export const getCellState = (item: { allergens: AllergenBlock | null }, key: AllergenKey): AllergenCellState => {
  if (item.allergens?.contains?.includes(key)) return 'contains'
  if (item.allergens?.modifiable?.includes(key)) return 'modifiable'
  return 'none'
}
